import { pathMap } from '@/navigation/paths';
import { Info } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const NavigateToExerciseDetailsButton = (props: { exerciseId: string }) => {
  const navigate = useNavigate();
  const { exerciseId } = props;

  return (
    <Tooltip title="Open Exercise description">
      <IconButton
        onClick={(e) => {
          navigate(`${pathMap.ExerciseDetails}/${exerciseId}`);
        }}
      >
        <Info />
      </IconButton>
    </Tooltip>
  );
};
